import { render } from "./MiningLine.vue?vue&type=template&id=397d280e"
import script from "./MiningLine.vue?vue&type=script&lang=js"
export * from "./MiningLine.vue?vue&type=script&lang=js"
script.render = render

export default script